import React, { useState, useEffect } from 'react';
import { useDialog } from '../DialogContext'; 

const VINTAGE_BEIGE = "#e5d1a5"; 
const JERUSALEM_GOLD = "#c5a059"; 

const JournalBook = ({ player, journalPageIndex, setJournalPageIndex, inputs, setInputs, setPlayer }) => {
  const entries = player.journal || [];
  
  const [isEditing, setIsEditing] = useState(false);
  const [editText, setEditText] = useState("");
  const [editTitle, setEditTitle] = useState("");
  
  // Sadece tarihi (saat olmadan) varsayılan başlık yapıyoruz ki daha estetik dursun
  const defaultTitle = new Date().toLocaleDateString();
  const [draftTitle, setDraftTitle] = useState(defaultTitle);

  const { showConfirm } = useDialog();

  useEffect(() => {
    setIsEditing(false);
    setEditText("");
    setEditTitle("");
  }, [journalPageIndex]);

  const handleSaveDraft = () => {
    if (!inputs.journalEntry.trim()) return;
    
    const newEntry = { 
      id: Date.now(), 
      date: new Date().toLocaleString(), // Alt başlıkta detaylı tarih kalsın
      title: draftTitle.trim() || defaultTitle, 
      text: inputs.journalEntry 
    };

    setPlayer(prev => ({ 
      ...prev, 
      journal: [newEntry, ...(prev.journal || [])] 
    }));
    
    setInputs(prev => ({ ...prev, journalEntry: "" }));
    setDraftTitle(defaultTitle);
    setJournalPageIndex(1); 
  };

  const handleEditStart = (entry) => {
    setEditTitle(entry.title || entry.date);
    setEditText(entry.text);
    setIsEditing(true);
  };

  const handleEditSave = (id) => {
    if (!editText.trim()) return;
    
    setPlayer(prev => ({
      ...prev,
      journal: (prev.journal || []).map(entry => 
        entry.id === id 
          ? { ...entry, title: editTitle.trim() || entry.date, text: editText, lastEdited: new Date().toLocaleString() } 
          : entry
      )
    }));
    setIsEditing(false);
  };

  const handleDelete = (id) => {
    showConfirm("Burn this page from the Chronicles? This action cannot be undone.", () => {
      setPlayer(prev => ({
        ...prev,
        journal: (prev.journal || []).filter(entry => entry.id !== id)
      }));
      setJournalPageIndex(0);
      setIsEditing(false);
    }, "Burn Page");
  };

  const activeEntry = journalPageIndex > 0 ? entries[journalPageIndex - 1] : null;

  // ÇİZGİLERİN KUSURSUZ HİZALANMASI
  const linedPaperStyle = {
    flex: 1, width: '100%', backgroundColor: 'transparent', border: 'none', outline: 'none',
    color: '#fdfbf7', fontFamily: 'Courier Prime, monospace', fontSize: '1.1rem', 
    lineHeight: '35px', padding: '0 15px', resize: 'none',
    backgroundImage: `repeating-linear-gradient(transparent, transparent 34px, rgba(197, 160, 89, 0.15) 34px, rgba(197, 160, 89, 0.15) 35px)`,
    backgroundAttachment: 'local'
  };

  return (
    <div style={{
      display: 'flex', height: '80vh', 
      backgroundColor: 'var(--sidebar-bg)', 
      border: `1px solid ${JERUSALEM_GOLD}`, borderRadius: '2px', 
      boxShadow: 'inset 0 0 50px rgba(0,0,0,0.5), 0 10px 30px rgba(0,0,0,0.3)', 
      overflow: 'hidden'
    }}>
      
      {/* --- INDEX (LEFT PAGE) --- */}
      <div style={{
        width: '32%', display: 'flex', flexDirection: 'column', 
        backgroundColor: 'rgba(0, 0, 0, 0.4)', 
        borderRight: `1px solid ${JERUSALEM_GOLD}`,
        boxShadow: 'inset -15px 0 20px -15px rgba(0,0,0,0.8)' 
      }}>
        
        <div style={{padding: '35px 25px 20px', borderBottom: `1px dashed ${JERUSALEM_GOLD}`}}>
<h3 style={{
  fontFamily: 'Cinzel, serif', 
  color: JERUSALEM_GOLD, 
  margin: 0, 
  letterSpacing: '2px', 
  textTransform: 'uppercase', 
  fontSize: '1.5rem', // Diğerlerinden çok hafif küçük, çünkü yan panelde duruyor
  textShadow: '1px 1px 3px rgba(0,0,0,0.8)'
}}>
  The Chronicles
</h3>
        </div>
        
        <div style={{flex: 1, overflowY: 'auto', padding: '15px 0', display: 'flex', flexDirection: 'column'}}>
          
          <div 
            onClick={() => setJournalPageIndex(0)}
            style={{
              padding: '15px 25px', cursor: 'pointer', fontFamily: 'Courier Prime, monospace', 
              fontWeight: 'bold', fontSize: '0.95rem', transition: 'all 0.2s', display: 'flex', alignItems: 'center', gap: '10px',
              backgroundColor: journalPageIndex === 0 ? 'rgba(139, 58, 58, 0.2)' : 'transparent',
              color: journalPageIndex === 0 ? JERUSALEM_GOLD : VINTAGE_BEIGE,
              borderLeft: journalPageIndex === 0 ? '4px solid var(--accent-red)' : '4px solid transparent'
            }}
            onMouseOver={(e) => { if(journalPageIndex !== 0) { e.currentTarget.style.backgroundColor = 'rgba(197, 160, 89, 0.1)'; e.currentTarget.style.color = JERUSALEM_GOLD; } }}
            onMouseOut={(e) => { if(journalPageIndex !== 0) { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = VINTAGE_BEIGE; } }}
          >
            <span style={{fontSize: '1.2rem'}}>✒️</span> DRAFT NEW ENTRY
          </div>

          <div style={{width: '80%', height: '1px', backgroundColor: 'rgba(197, 160, 89, 0.2)', margin: '10px auto'}}></div>

          {entries.length === 0 ? (
             <div style={{padding: '20px 25px', opacity: 0.6, fontStyle: 'italic', fontFamily: 'Courier Prime, monospace', fontSize: '0.85rem', color: VINTAGE_BEIGE}}>
               Your history is unwritten.
             </div>
          ) : (
            entries.map((entry, idx) => (
              <div 
                key={entry.id} 
                onClick={() => setJournalPageIndex(idx + 1)}
                style={{
                  padding: '12px 25px', cursor: 'pointer', fontFamily: 'Courier Prime, monospace', 
                  fontSize: '0.95rem', transition: 'all 0.2s', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                  backgroundColor: journalPageIndex === idx + 1 ? 'rgba(139, 58, 58, 0.2)' : 'transparent',
                  color: journalPageIndex === idx + 1 ? JERUSALEM_GOLD : VINTAGE_BEIGE,
                  borderLeft: journalPageIndex === idx + 1 ? '4px solid var(--accent-red)' : '4px solid transparent'
                }}
                onMouseOver={(e) => { if(journalPageIndex !== idx + 1) { e.currentTarget.style.backgroundColor = 'rgba(197, 160, 89, 0.1)'; e.currentTarget.style.color = JERUSALEM_GOLD; } }}
                onMouseOut={(e) => { if(journalPageIndex !== idx + 1) { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = VINTAGE_BEIGE; } }}
                title={entry.title || entry.date}
              >
                {entry.title || entry.date}
              </div>
            ))
          )}
        </div>
      </div>

      {/* --- CONTENT (RIGHT PAGE) --- */}
      <div style={{
        flex: 1, padding: '40px 50px', display: 'flex', flexDirection: 'column', 
        backgroundColor: 'rgba(0,0,0,0.2)', 
        backgroundImage: `url('https://www.transparenttextures.com/patterns/aged-paper.png')`,
        boxShadow: 'inset 15px 0 20px -15px rgba(0,0,0,0.8)',
        minHeight: 0 // Scroll hatasını önlemek için Flexbox kilidi
      }}>
        
        {journalPageIndex === 0 ? (
          // DRAFT (NEW ENTRY)
          <div style={{flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0}}>
            <div style={{borderBottom: `1px solid ${JERUSALEM_GOLD}`, paddingBottom: '15px', marginBottom: '25px', display: 'flex', flexDirection: 'column', gap: '10px'}}>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <span style={{fontFamily: 'Cinzel, serif', color: 'var(--accent-red)', fontSize: '0.9rem', letterSpacing: '2px', textTransform: 'uppercase', fontWeight: 'bold'}}>
                  New Chapter
                </span>
                <span style={{fontFamily: 'Courier Prime, monospace', fontSize: '0.85rem', color: VINTAGE_BEIGE, opacity: 0.8}}>
                  {defaultTitle}
                </span>
              </div>
              
              {/* BAŞLIK GİRİŞİ: FONT KÜÇÜLTÜLDÜ (1.5rem) */}
              <input 
                className="vintage-input"
                value={draftTitle}
                onChange={(e) => setDraftTitle(e.target.value)}
                placeholder="Title of this entry..."
                style={{
                  fontFamily: 'Cinzel, serif', color: JERUSALEM_GOLD, fontSize: '1.5rem', 
                  backgroundColor: 'transparent', border: 'none', outline: 'none', fontWeight: 'bold'
                }}
              />
            </div>
            
            <textarea 
              className="vintage-input"
              value={inputs.journalEntry} 
              onChange={e => setInputs({...inputs, journalEntry: e.target.value})} 
              placeholder="Record your thoughts, architect your legacy..."
              spellCheck="false"
              style={linedPaperStyle}
            />
            
            <button 
              className="wax-seal-btn" 
              style={{
                alignSelf: 'flex-end', marginTop: '25px', padding: '12px 35px', fontSize: '1rem', 
                fontFamily: 'Cinzel, serif', letterSpacing: '2px', borderRadius: '2px',
                backgroundColor: 'var(--accent-red)', color: JERUSALEM_GOLD, border: '1px solid #5a0d0e',
                boxShadow: '0 4px 10px rgba(0,0,0,0.5)', transition: 'all 0.2s'
              }}
              onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#5a0d0e'; e.currentTarget.style.borderColor = JERUSALEM_GOLD; e.currentTarget.style.transform = 'translateY(-2px)'; }}
              onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'var(--accent-red)'; e.currentTarget.style.borderColor = '#5a0d0e'; e.currentTarget.style.transform = 'translateY(0)'; }}
              onClick={handleSaveDraft}
            >
              SEAL & RECORD
            </button>
          </div>
        ) : (
          // READING / EDITING ENTRY
          activeEntry && (
            <div style={{display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0}}>
              
              {!isEditing ? (
                <div style={{borderBottom: `1px solid ${JERUSALEM_GOLD}`, paddingBottom: '15px', marginBottom: '25px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
                  <div>
                    {/* OKUMA MODU BAŞLIĞI: FONT KÜÇÜLTÜLDÜ (1.5rem) */}
                    <h3 style={{fontFamily: 'Cinzel, serif', color: JERUSALEM_GOLD, margin: '0 0 5px 0', fontSize: '1.5rem', textShadow: '1px 1px 3px rgba(0,0,0,0.8)'}}>
                      {activeEntry.title || activeEntry.date}
                    </h3>
                    {activeEntry.title && activeEntry.title !== activeEntry.date && (
                      <span style={{fontFamily: 'Courier Prime, monospace', fontSize: '0.85rem', color: VINTAGE_BEIGE, opacity: 0.8}}>
                        {activeEntry.date}
                      </span>
                    )}
                  </div>
                  
                  <div style={{display: 'flex', gap: '8px', marginTop: '5px'}}>
                    <button 
                      onClick={() => handleEditStart(activeEntry)}
                      style={{background: 'transparent', border: `1px solid ${JERUSALEM_GOLD}`, color: JERUSALEM_GOLD, padding: '6px 15px', cursor: 'pointer', fontFamily: 'Cinzel, serif', fontWeight: 'bold', fontSize: '0.8rem', letterSpacing: '1px', borderRadius: '2px', transition: 'all 0.2s'}}
                      onMouseOver={(e) => { e.currentTarget.style.backgroundColor = 'rgba(197, 160, 89, 0.1)'; }}
                      onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                    >
                      EDIT
                    </button>
                    <button 
                      onClick={() => handleDelete(activeEntry.id)}
                      style={{background: 'transparent', border: '1px solid var(--accent-red)', color: 'var(--accent-red)', padding: '6px 15px', cursor: 'pointer', fontFamily: 'Cinzel, serif', fontWeight: 'bold', fontSize: '0.8rem', letterSpacing: '1px', borderRadius: '2px', transition: 'all 0.2s'}}
                      onMouseOver={(e) => { e.currentTarget.style.backgroundColor = 'rgba(123, 17, 19, 0.2)'; }}
                      onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                    >
                      DELETE
                    </button>
                  </div>
                </div>
              ) : (
                <div style={{borderBottom: '1px dashed var(--accent-red)', paddingBottom: '15px', marginBottom: '25px'}}>
                   <span style={{fontFamily: 'Cinzel, serif', color: 'var(--accent-red)', fontSize: '0.8rem', letterSpacing: '2px', textTransform: 'uppercase'}}>
                     Editing Chronicle
                   </span>
                   {/* DÜZENLEME MODU BAŞLIĞI: FONT KÜÇÜLTÜLDÜ (1.5rem) */}
                   <input 
                    className="vintage-input"
                    value={editTitle}
                    onChange={(e) => setEditTitle(e.target.value)}
                    placeholder="Entry Title"
                    style={{
                      fontFamily: 'Cinzel, serif', color: JERUSALEM_GOLD, fontSize: '1.5rem', 
                      backgroundColor: 'rgba(0,0,0,0.3)', border: 'none', outline: 'none', fontWeight: 'bold',
                      width: '100%', marginTop: '8px', padding: '10px', borderRadius: '2px'
                    }}
                  />
                </div>
              )}

              {isEditing ? (
                <div style={{flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0}}>
                  <textarea 
                    className="vintage-input"
                    value={editText} 
                    onChange={e => setEditText(e.target.value)} 
                    spellCheck="false"
                    style={{ ...linedPaperStyle, backgroundColor: 'rgba(0,0,0,0.3)', border: `1px dashed ${JERUSALEM_GOLD}`, borderRadius: '2px' }}
                    autoFocus
                  />
                  <div style={{display: 'flex', gap: '15px', marginTop: '25px', justifyContent: 'flex-end'}}>
                    <button 
                      style={{background: 'transparent', border: `1px solid ${VINTAGE_BEIGE}`, color: VINTAGE_BEIGE, padding: '10px 25px', cursor: 'pointer', fontFamily: 'Cinzel, serif', fontWeight: 'bold', letterSpacing: '1px', borderRadius: '2px', transition: '0.2s'}} 
                      onMouseOver={(e) => { e.currentTarget.style.backgroundColor = 'rgba(229, 209, 165, 0.1)'; }}
                      onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                      onClick={() => setIsEditing(false)}
                    >
                      CANCEL
                    </button>
                    <button 
                      className="wax-seal-btn" 
                      style={{
                        padding: '10px 25px', borderRadius: '2px', fontSize: '1rem', letterSpacing: '1px', 
                        backgroundColor: 'var(--accent-red)', color: JERUSALEM_GOLD, border: '1px solid #5a0d0e', transition: 'all 0.2s'
                      }} 
                      onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#5a0d0e'; e.currentTarget.style.borderColor = JERUSALEM_GOLD; e.currentTarget.style.transform = 'translateY(-2px)';}}
                      onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'var(--accent-red)'; e.currentTarget.style.borderColor = '#5a0d0e'; e.currentTarget.style.transform = 'translateY(0)';}}
                      onClick={() => handleEditSave(activeEntry.id)}
                    >
                      SAVE CHANGES
                    </button>
                  </div>
                </div>
              ) : (
                <div style={{flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0}}>
                  {/* DİKKAT: OKUMA MODU ARTIK READONLY BİR TEXTAREA! BU SAYEDE KAYDIRMA VE ÇİZGİLER KUSURSUZ ÇALIŞIR */}
                  <textarea 
                    className="vintage-input"
                    value={activeEntry.text} 
                    readOnly
                    style={{ ...linedPaperStyle, cursor: 'default' }}
                  />
                  
                  {activeEntry.lastEdited && (
                    <div style={{textAlign: 'right', marginTop: '20px', fontFamily: 'Courier Prime, monospace', fontSize: '0.8rem', color: VINTAGE_BEIGE, fontStyle: 'italic', opacity: 0.7}}>
                      Last Updated: {activeEntry.lastEdited}
                    </div>
                  )}
                </div>
              )}
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default JournalBook;